import React, { useContext } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import isEmpty from '../../utils/isEmpty';
import Icon from '../Icon';
import styles from './InfoBox.module.scss';
import { SiteSettingContext } from '../../containers/BasePage/BasePage';
import { useTranslation } from 'next-i18next';

const styledAddress = (address) =>
    address.split(',').map((item, i) => {
        return <p key={i}>{item}</p>;
    });

const googleMapsLink = (address) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address
    )}`;

const cleanTelephone = (telephone) => telephone.replace(/[^\d]/g, '');

const InfoBox = ({
    title = '',
    text = '',
    address = '',
    telephone = '',
    href = '',
    label = '',
    bookingHref,
    bookingLabel,
    closestStation,
    modifiers = [],
    heading,
    city,
    zipCode,
    hasRichtext = false,
}) => {
    const siteSetting = useContext(SiteSettingContext);
    const { t } = useTranslation();

    if (
        isEmpty(title) &&
        isEmpty(text) &&
        isEmpty(address) &&
        isEmpty(telephone) &&
        isEmpty(href) &&
        isEmpty(label) &&
        isEmpty(address) &&
        isEmpty(bookingHref)
    ) {
        return null;
    }

    if (text) {
        text = text.split('</a>').join('<span></span></a>');
    }

    const classes = classNames(
        styles['InfoBox'],
        modifiers.map((mod) => styles['InfoBox--' + mod])
    );

    console.log(address, city, zipCode);

    return (
        <section className={classes}>
            {heading && (
                <h2 className={styles['InfoBox__Heading']}>{heading}</h2>
            )}
            {address && address.length > 2 && (
                <div className={styles['InfoBox__AddressWrapper']}>
                    <div className={styles['InfoBox__IconMargin']}>
                        <div className="InfoBox__AddressIconWrapper">
                            <Icon type="place" size="large" color="black800" />
                        </div>
                    </div>
                    <div className={styles['InfoBox__AddressBox']}>
                        {title && (
                            <div className={styles['InfoBox__Venue']}>
                                {title}
                            </div>
                        )}

                        <div className={styles['InfoBox__Address']}>
                            {styledAddress(address)}
                            {zipCode && <p>{zipCode}</p>}
                            {city && <p>{city}</p>}
                            {zipCode && <p>{zipCode}</p>}
                            {city && <p>{city}</p>}
                        </div>

                        <a
                            className={styles['InfoBox__LinkExternal']}
                            href={googleMapsLink(address)}
                            target="_blank"
                            rel="noopener noreferrer">
                            {t('EventPage.mapsLink')}
                            <span className={styles['InfoBox__IconExternal']}>
                                <Icon
                                    type="external"
                                    size="small"
                                    color="pink700"
                                />
                            </span>
                        </a>
                    </div>
                </div>
            )}
            {/* {hasRichtext && text && (
                <div className={styles['InfoBox__TextWrapper']}>
                    <div
                        className={styles['InfoBox__Text']}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </div>
            )} */}
            {telephone && (
                <div className={styles['InfoBox__TelephoneWrapper']}>
                    <div className={styles['InfoBox__IconMargin']}>
                        <Icon type="phone" size="large" color="black800" />
                    </div>
                    <a
                        className={styles['InfoBox__Link']}
                        href={'tel:' + cleanTelephone(telephone)}>
                        {telephone}
                    </a>
                </div>
            )}

            {!!closestStation && closestStation.name && (
                <div className={styles['InfoBox__AddressWrapper']}>
                    <div className={styles['InfoBox__IconMargin']}>
                        <div className="InfoBox__AddressIconWrapper">
                            <Icon type="bus" size="large" color="black800" />
                        </div>
                    </div>
                    <div className={styles['InfoBox__ClosestStation']}>
                        <p>
                            {t('InfoBox.closestStation')} {closestStation.name}
                        </p>
                        {closestStation.lang === 'sv' ? (
                            siteSetting?.sl?.websiteLink && (
                                <a
                                    className={styles['InfoBox__Link']}
                                    href={siteSetting.sl.websiteLink}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {t('InfoBox.swe')}
                                </a>
                            )
                        ) : (
                            <>
                                {siteSetting?.sl?.iosDownloadLink && (
                                    <p>
                                        <a
                                            className={
                                                styles['InfoBox__LinkExternal']
                                            }
                                            href={
                                                siteSetting.sl.iosDownloadLink
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            {t('InfoBox.ios')}
                                            <span
                                                className={
                                                    styles[
                                                        'InfoBox__IconExternal'
                                                    ]
                                                }>
                                                <Icon
                                                    type="external"
                                                    size="small"
                                                    color="pink700"
                                                />
                                            </span>
                                        </a>
                                    </p>
                                )}
                                {siteSetting?.sl?.androidDownloadLink && (
                                    <p>
                                        <a
                                            className={
                                                styles['InfoBox__LinkExternal']
                                            }
                                            href={
                                                siteSetting.sl
                                                    .androidDownloadLink
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            {t('InfoBox.android')}
                                            <span
                                                className={
                                                    styles[
                                                        'InfoBox__IconExternal'
                                                    ]
                                                }>
                                                <Icon
                                                    type="external"
                                                    size="small"
                                                    color="pink700"
                                                />
                                            </span>
                                        </a>
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            )}
            {(bookingHref || href) && (
                <div className={styles['InfoBox__LinkWrapper']}>
                    <div className={styles['InfoBox__IconMargin']}>
                        <Icon type="external" size="large" color="black800" />
                    </div>
                    <a
                        className={styles['InfoBox__Link']}
                        href={bookingHref || href}
                        target="_blank"
                        rel="noopener noreferrer">
                        {bookingHref
                            ? bookingLabel || bookingHref
                            : label || href}
                    </a>
                </div>
            )}
        </section>
    );
};

InfoBox.propTypes = {
    address: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
    telephone: PropTypes.string,
};

export default InfoBox;
